import { ArrowDownIcon, ArrowUpIcon, MinusIcon } from '@phosphor-icons/react';
import { periodChange } from '@logspot-platform/platform-types';
import { Badge } from '@logspot-platform/ui/badge';

const VARIANT = { up: 'success', down: 'error', flat: 'neutral' } as const;

export const ChangeBadge = ({
  current,
  previous,
}: {
  current: number;
  previous: number;
}) => {
  const change = periodChange(current, previous);
  if (change.kind === 'none') return null;
  return (
    <Badge variant={VARIANT[change.kind]}>
      {change.kind === 'down' && <ArrowDownIcon weight="bold" />}
      {change.kind === 'flat' && <MinusIcon weight="bold" />}
      {change.kind === 'up' && <ArrowUpIcon weight="bold" />}
      <span className="text-muted-foreground">
        {change.percent.toFixed(0)}%
      </span>
    </Badge>
  );
};
